let userIsLoggedIn = siteData.is_user_logged_in ? true : false
let wpRestNonce = siteData.wp_rest_nonce
let inGdprZone = siteData.in_gdpr_zone
let cookieConsent = siteData.cookie_consent
let locale = siteData.locale_base
const nativeConnection = !! window.navigator.connection

const initialState = {
	userIsLoggedIn: userIsLoggedIn,
	wpRestNonce: wpRestNonce,
	inGdprZone: inGdprZone,
	cookieConsent: cookieConsent,
	locale: locale,
	locales: siteData.locales,
	connection: {
		onLine: true,
		possiblySlowNetwork: false, // Guessed connection speed when nativeConnection is not available.
		downlink: nativeConnection ? navigator.connection.downlink : false, // Megabits per second.
		rtt: nativeConnection ? navigator.connection.rtt : false, // Ms.
		effectiveType: nativeConnection ? navigator.connection.effectiveType : false, // 'slow-2g', '2g', '3g', or '4g'.
	},
	loadedScripts: [],
	loginIsDisabled: false,
	loginIsProcessing: false,
	loginIsProcessed: false,
	loginError: false,
	loginSuccess: false,
	loginMessage: false,
	menuIsOpen: false,
	latestIssue: siteData.latest_issue,
	pastIssues: {}
}

export default function pageReducer( state = initialState, action ) {
	const { type, payload } = action

	switch ( type ) {
		case 'ADD_SCRIPT':
			return {
				...state,
				loadedScripts: [
					...state.loadedScripts,
					payload
				]
			}

		case 'SET_COOKIE_CONSENT':
			return {
				...state,
				cookieConsent: payload
			}

		case 'SET_ONLINE_STATUS':
			return {
				...state,
				connection: {
					...state.connection,
					onLine: payload
				}
			}

		case 'SET_CONNECTION_STATUS':
			return {
				...state,
				connection: {
					...state.connection,
					...payload
				}
			}

		case 'SET_LOCALE':
			return {
				...state,
				locale: payload
			}

		case 'LOGIN':
			return {
				...state,
				userIsLoggedIn: true,
				loginError: false
			}

		case 'LOGIN_DISABLED':
			return {
				...state,
				loginIsDisabled: payload,
				loginError: false,
				loginSuccess: false
			}

		case 'LOGIN_PROCESSING':
			return {
				...state,
				loginIsProcessing: true,
				loginIsProcessed: false,
				loginError: false,
				loginSuccess: false
			}

		case 'LOGIN_PROCESSED':
			return {
				...state,
				loginIsProcessed: true,
				loginIsProcessing: false
			}

		case 'LOGIN_ERROR':
			return {
				...state,
				loginError: true,
				loginIsProcessed: false
			}

		case 'LOGIN_SUCCESS':
			return {
				...state,
				loginSuccess: true,
				loginIsProcessed: false
			}

		case 'LOGIN_MESSAGE':
			return {
				...state,
				loginMessage: action.message
			}

		case 'LOGOUT':
			return {
				...state,
				userIsLoggedIn: false
			}

		case 'OPEN_MENU':
			return {
				...state,
				menuIsOpen: true
			}

		case 'CLOSE_MENU':
			return {
				...state,
				menuIsOpen: false
			}

		case 'RECEIVE_PAST_ISSUES_DATA':
			return {
				...state,
				pastIssues: payload
			}
	}

	return state
}
